import { ReactComponent as FlagIcon } from "./svg/de-flag.svg";
import "../flag-icon.scss";

export const DEFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
